import React, { FunctionComponent, useCallback, useMemo } from "react";
import useRefinementEffects from "@/use-refinement-effects";

import { fuelTypes } from "@/types";
import useRefinementStore from "@/use-refinement-store";
import useGtagEffects from "@/use-gtag-effects";

const Refine: FunctionComponent<RefineProps> = () => {
  const { setServices } = useRefinementEffects();
  const services = useRefinementStore((store) => store.services);
  const { triggerCustomEvent } = useGtagEffects();

  const onChangeHandler = useCallback(
    (i: React.FormEvent<HTMLSelectElement>) => {
      const value = i.currentTarget.value;

      if (value === "all") {
        setServices(null);
        triggerCustomEvent("fuel_finder_search_by_type", {
          event_category: "Filter",
          event_label: "Filter by Fuel Type",
          fuel_type: "all",
        });
      } else {
        setServices([value]);
        triggerCustomEvent("fuel_finder_search_by_type", {
          event_category: "Filter",
          event_label: "Filter by Fuel Type",
          fuel_type: value,
        });
      }
    },
    [setServices, triggerCustomEvent]
  );

  const value = useMemo(() => {
    if (services != null && services.length > 0) {
      return services[0];
    }
  }, [services]);

  return (
    <select
      onChange={onChangeHandler}
      className="tw-p-1 tw-m-2 tw-min-w-24 tw-font-header"
      style={{ paddingRight: "2rem" }}
      value={value}
    >
      <option value="all">Filter by Fuel Type</option>
      {(Object.keys(fuelTypes) as (keyof typeof fuelTypes)[]).map((key) => (
        <option value={key} key={key}>
          {fuelTypes[key]}
        </option>
      ))}
    </select>
  );
};

export type RefineProps = {};

export default React.memo(Refine);
